function makeAuthorLabel({
  author_display_name,
  display_name,
  author_username,
  username,
}) {
  const name =
    author_display_name || display_name || author_username || username;

  return name ? "by " + name : "";
}

module.exports = makeAuthorLabel;
